import { notification } from "antd";
import {
  PUBLISH_FORM_REQUEST,
  PUBLISH_FORM_SUCCESS,
  PUBLISH_FORM_FAILURE,
} from "../Types";
import { DcOffLineHost } from "../../config"; 

 export const publishFormulaire = (formId) => {
  return async (dispatch) => {
    dispatch({ type: PUBLISH_FORM_REQUEST });

    try {
      const token = localStorage.getItem("token");

      if (!token) {
        throw new Error("Aucun token trouvé, veuillez vous reconnecter.");
      }

      const response = await fetch(
        `${DcOffLineHost}api/forms/publishForm/${formId}/publish`,
        {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
          },
        }
      );


      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message || "Erreur lors de la publication du formulaire");
      }

      dispatch({ type: PUBLISH_FORM_SUCCESS, payload: data });

      notification.success({
        message: data?.message || "Formulaire publié avec succès",
        duration: 5,
      });

      return data;
    } catch (error) {
      dispatch({ type: PUBLISH_FORM_FAILURE, payload: error?.message });

      notification.error({
        message: error?.message || "Erreur lors de la publication du formulaire",
        duration: 5,
      });
    }
  };
};
